import { render, staticRenderFns } from "./accountRegister.vue?vue&type=template&id=7fcc80b0&scoped=true&"
import script from "./accountRegister.vue?vue&type=script&lang=js&"
export * from "./accountRegister.vue?vue&type=script&lang=js&"
import style0 from "./accountRegister.vue?vue&type=style&index=0&id=7fcc80b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fcc80b0",
  null
  
)

export default component.exports